var site = window.site || {};
// eslint-disable-next-line no-use-before-define
var generic = generic || {};
// eslint-disable-next-line no-use-before-define
var prodcat = prodcat || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};

(function ($) {
  Drupal.behaviors.ProductRecommendationsV2 = {
    attached: false,
    isMobile: false,

    attach: function (context) {
      var self = this;
      var $containers = $();

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.isMobile = Unison.fetch.now().name === 'small';
      $containers = $('.js-product-recommendations', context);

      $containers.each(function () {
        self.init($(this));
      });
    },

    init: function ($container) {
      var self = this;
      var placementId;
      var eventType;
      var resultsCount;
      var googleFilter;
      var useNGGlobal;
      var dryRun;
      var productId;

      placementId = $container.data('placement-id');
      eventType = $container.data('event-type');
      resultsCount =
        $container.data('results-count') < 100 ? $container.data('results-count') : 100;
      googleFilter = $container.data('filter');
      useNGGlobal = $container.data('use-ngglobal').toString();
      dryRun = $container.data('dry-run').toString() === 'true';
      productId = (
        page_data &&
        page_data['catalog-spp'] &&
        page_data['catalog-spp'].products &&
        page_data['catalog-spp'].products[0]
          ? page_data['catalog-spp'].products[0].PRODUCT_ID
          : ''
      ).replace(/^PROD/, '');

      self.loadRecommendations(
        $container,
        placementId,
        eventType,
        resultsCount,
        googleFilter,
        useNGGlobal,
        dryRun,
        productId
      );
    },

    loadRecommendations: function (
      $container,
      placementId,
      eventType,
      resultsCount,
      googleFilter,
      useNGGlobal,
      dryRun,
      productId
    ) {
      var self = this;
      var params = self.buildDataObject(
        placementId,
        eventType,
        resultsCount,
        googleFilter,
        useNGGlobal,
        dryRun,
        productId
      );

      self.getRecommendations($container, params);
    },

    buildDataObject: function (
      placementId,
      eventType,
      resultsCount,
      googleFilter,
      useNGGlobal,
      dryRun,
      productId
    ) {
      return {
        useNGGlobal: useNGGlobal,
        dryRun: dryRun,
        eventType: eventType,
        placementId: placementId,
        pageSize: resultsCount,
        filter: googleFilter,
        productId: productId
      };
    },

    getRecommendations: function ($container, params) {
      var self = this;
      var data;

      params.includeProducts = true;

      generic.jsonrpc.fetch({
        method: 'user.googleAIRecommend',
        params: [params],
        onSuccess: (response) => {
          data = JSON.parse(response.getValue());

          if (data && data.results && data.results.length !== 0) {
            self.processResponse($container, data);
          } else {
            $container.toggleClass('hidden');
          }
        }
      });
    },

    processResponse: function ($container, data) {
      var self = this;
      var items = [];
      var recommendationToken = data.recommendationToken;

      data.results.forEach((result) => {
        items.push(result.product);
      });

      self.getPerlgemProductData($container, items);

      if (site.trackingDataLayer) {
        site.trackingDataLayer.update({
          aiRecommendationToken: recommendationToken
        });
      }
    },

    getPerlgemProductData: function ($container, results) {
      var self = this;

      const products = _.compact(results);
      prodcat.data.updateProducts(products); // TBD whether this is necessary since we call this later

      // Modify the product data from perlgem to work within the JS templates
      const newProducts = products
        .map((p) => {
          var defaultSku;
          var skuLength;
          var sku;
          var productData = prodcat.data.getProduct(p.PRODUCT_ID);
          var i;

          if (!productData || !productData['skus']) {
            return false;
          }

          const hasResponsiveImages =
            Drupal?.settings?.global_variables?.product_responsive_images || false;
          const key = hasResponsiveImages ? 'IMAGE_MEDIUM' : 'IMAGE_M_V2';

          skuLength = productData['skus'].length;
          productData['sku_count'] = skuLength <= 1 ? 0 : skuLength;

          for (i = 0; i < skuLength; i++) {
            sku = productData['skus'][i];

            sku.IMAGE_MEDIUM_COMBINED = [];
            sku.IMAGE_MEDIUM_COMBINED = key in sku ? sku[key] : sku.IMAGE_ALT_L;

            if (sku['DEFAULT_SKU'] === 1) {
              defaultSku = sku;
              break;
            }
          }
          if (!defaultSku) {
            defaultSku = productData['skus'][0];
          }
          productData['defaultSku'] = defaultSku;
          productData['globals'] = {
            t: site.translations,
            variables: Drupal.settings.global_variables
          };

          return productData;
        })
        .filter(Boolean);

      prodcat.data.updateProducts(newProducts);

      self.renderProductGrid($container, newProducts);
    },

    renderProductGrid: function ($container, products) {
      // Assemble Custom config for the 'product_grid_v3' JS template
      const template_config = {
        animate_cta: true,
        bypass_reorder: true,
        cols__small: 1,
        cols__medium: 2,
        cols__large: 4,
        globals: {
          t: site.translations,
          variables: Drupal.settings.global_variables
        },
        hide_sort: true,
        hide_ratings: false,
        hide_price: false,
        is_carousel: true,
        product_filters: false,
        quickshop_link_v2: false,
        disable_infinite_carousel: true,
        products
      };
      // Render the grid client-side
      const $grid = $('.js-product-recommendations-grid', $container);
      const product_grid_html = site.template.get({
        name: 'product_grid_v3',
        data: template_config
      });

      $grid.html(product_grid_html);

      Drupal.attachBehaviors($grid);
    }
  };
})(jQuery);
